import React, { useEffect, useMemo, useState } from 'react';

import { DesignLayout } from '@common/DesignLayout';
import { Tabs } from '@common/Tabs';
import { usePermission } from '@src/utils/hooks/usePermission';
import { organizationsStore } from '@stores/dictionaryStores/organizationsStore';

import { Filter } from './Filter';
import { PassingControl } from './PassingControl';
import { PublicationRegister } from './PublicationRegister';

import styles from './PreparationOfReports.module.scss';

export const PreparationOfReports = (): React.ReactElement => {
  const [tab, setTab] = useState('');
  const [organizationCode, setOrganizationCode] = useState('');
  const [filters, setFilters] = useState<{ [index: string]: string | undefined }>({});

  const { organizations } = organizationsStore;

  const cmCompanyReport = usePermission('CmCompanyReport');
  const cmCtrlCompanyReport = usePermission('CmCtrlCompanyReport');

  useEffect(() => {
    setTab(!cmCompanyReport.VIEW ? 'passingControl' : 'publicationRegister');
  }, [cmCompanyReport.VIEW]);

  const tabs = useMemo(
    () => (
      <Tabs
        tabs={[
          { title: 'Подготовка отчетности', key: 'publicationRegister', hidden: !cmCompanyReport.VIEW },
          { title: 'Прохождение КП', key: 'passingControl', hidden: !cmCtrlCompanyReport.VIEW },
        ]}
        active={tab}
        onChange={setTab}
      />
    ),
    [cmCompanyReport.VIEW, cmCtrlCompanyReport.VIEW, tab],
  );

  useEffect(() => {
    const storage = localStorage.getItem('pushFromDataControl');
    const parseStorage = storage ? JSON.parse(storage) : null;

    if (parseStorage) {
      setTab('passingControl');

      const code = parseStorage.packageCode.substring(0, parseStorage.packageCode?.lastIndexOf('_'));
      const name = organizations?.find((org) => org.code === code)?.name;
      setFilters({ organization: name });
      setOrganizationCode(code);
    }
  }, [organizations]);

  return (
    <DesignLayout scrollEnable>
      <div className={styles.wrapper}>
        <Filter
          filters={filters}
          setFilters={setFilters}
          organizationCode={organizationCode}
          setOrganizationCode={setOrganizationCode}
          tab={tab}
        />
        {tab === 'publicationRegister' && (
          <PublicationRegister tabs={tabs} filters={filters} organizationCode={organizationCode} />
        )}
        {tab === 'passingControl' && (
          <PassingControl tabs={tabs} filters={filters} organizationCode={organizationCode} />
        )}
      </div>
    </DesignLayout>
  );
};
